export const ACTIVATE_LINEAR_SESSION_KEY = 'activateLinearSessionId';
export const AMP_SESSION_ID_COOKIE_KEY = 'amplitudeSessionId';
export const AMP_DEVICE_ID_COOKIE_KEY = 'amplitudeDeviceId';
export const SUPPRESS_BANNER_KEY = 'suppressBannerId';
